import { DataService } from '../../data.service';
import { HttpClient } from '@angular/common/http';
import { Universitat } from '../model/Universitat';
import { Preinscripcio } from '../model/preinscripcio';
import { EstudisRealitzats } from '../model/estudiRealitzat';
import { DocumentPreinscripcio } from '../model/documentPreinscripcio';
import { Alumne } from '../model/alumne';
import { Oferta } from '../model/oferta';
import { Login } from '../model/login';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class BLPreinscripcio {

    constructor(
        private dataService: DataService,
        private http: HttpClient) {
    }

    get(login: Login, language: string): Promise<Preinscripcio> {
        const offset = new Date().getTimezoneOffset();
        const url = 'preinscripcio?dataNaixement=' + login.dataNaixement +
            '&documentIdentificatiu=' + login.documentIdentificatiu +
            '&oferta=' + login.oferta.value.toString() +
            '&language=' + language;
        return this.getCall(url);
    }

    getFromPayWSToken(paywstoken: string): Promise<Preinscripcio> {
        const url = 'preinscripcio/token?paywstoken=' + paywstoken;
        return this.getCall(url);
    }

    getCall(url: string): Promise<Preinscripcio> {
        return new Promise<Preinscripcio>((resolve, reject) => {
            this.http.get<Preinscripcio>(
                this.dataService.getApiEndpoint(url)).subscribe(data => {
                    let json = JSON.stringify(data);
                    console.log(json);
                    const p = this.initializePreinscripcio(data);
                    resolve(p);
                    console.log('Post-initialize');
                    json = JSON.stringify(p);
                    console.log(json);
                }, error => {
                    reject(error.error);
                });
            });
    }

    initializePreinscripcio(data: Preinscripcio): Preinscripcio {
        const p = new Preinscripcio();
        Object.assign(p, data); // Si es fa això sobreescriu els objectes de dins ...
        p.alumne = new Alumne();
        Object.assign(p.alumne, data.alumne);
        p.estudiRealitzat = new EstudisRealitzats();
        Object.assign(p.estudiRealitzat, data.estudiRealitzat);
        return p;
    }

    getDocuments(preinscripcio: Preinscripcio): Promise<DocumentPreinscripcio[]> {

        const pais = preinscripcio.estudiRealitzat.pais;
        const universitat = preinscripcio.estudiRealitzat.universitat;
        let url = 'preinscripcio/documents?oferta=' + preinscripcio.oferta.value.toString();
        if (pais != null && pais.value) {
            url += '&pais=' + pais.value;
        }
        if (universitat != null && universitat.value) {
            url += '&universitat=' + universitat.value;
        }
        url += '&language=' + preinscripcio.idioma;

        return new Promise<DocumentPreinscripcio[]>((resolve, reject) => {
            this.http.get<DocumentPreinscripcio[]>(
                this.dataService.getApiEndpoint(url)).subscribe(data => {
                    resolve(data);
                }, error => {
                    reject(error.error);
                });
            });
    }

    save(preinscripcio: Preinscripcio): Promise<Preinscripcio> {
        const json = JSON.stringify(preinscripcio);
        console.log(json);
        let url = 'preinscripcio?';
        url += 'language=' + preinscripcio.idioma;
        return new Promise<Preinscripcio>((resolve, reject) => {
            this.http.post<Preinscripcio>(this.dataService.getApiEndpoint(url), preinscripcio).subscribe(data => {
                const p = this.initializePreinscripcio(data);
                resolve(p);
            }, error => {
                reject(error.error);
            });
        });
    }

    validaDNI(document: String): Observable<boolean> {
        const url = 'preinscripcio/IsValidDNI?document=' + document;
        return this.http.get<boolean>(this.dataService.getApiEndpoint(url));
    }

    validaNIE(document: String): Observable<boolean> {
        const url = 'preinscripcio/IsValidNIE?document=' + document;
        return this.http.get<boolean>(this.dataService.getApiEndpoint(url));
    }

}



// WEBPACK FOOTER //
// ./src/app/lib/bl/blpreinscripcio.ts